import * as React from 'react';
import { useField } from 'oasis-os-contentful';
import { useAppState } from 'oasis-os-react';
import { useTheme } from 'oasis-os-theming';
import { AppHydration } from 'oasis-os-utils';

import {
  readGlobal,
  getLogger,
  setLoggerConfig,
  LoggerConfigurationInterface,
} from 'oasis-os-common';
import { ContentfulApp } from '../../types';
import { Simple, Standard } from '../Templates';
import Actions from '../Actions';
import handleLocalization, { Lang } from '../../utils/handleLocalization';
import getDefaultLocale from '../../utils/getDefaultLocale';

const logger = getLogger(PKG_NAME, PKG_VERSION, 'Viewport');

export default function Viewport() {
  const template = useField<string>('template');
  const [config = {} as ContentfulApp, ,] = useAppState<ContentfulApp>();
  const { fields: appConfig } = config;
  const [isLocalized, setIsLocalized] = React.useState<boolean>(false);
  const [, , app] = useAppState();
  const queryParamDeepLink = new URL(window.location.href)?.searchParams.get('link');
  const smartRedirect = new URL(window.location.href)?.searchParams.get('redirect');
  const nonce = new URL(window.location.href)?.searchParams.get('nonce');
  const lcid = new URL(window.location.href)?.searchParams.get('lcid');
  const payload = new URL(window.location.href)?.searchParams.get('payload');
  const modeType = readGlobal('$.global.value.functionalConfig.theme.mode');
  const loggerConfig = readGlobal(
    '$.global.value.functionalConfig.logger',
  ) as LoggerConfigurationInterface;
  React.useEffect(() => {
    if (loggerConfig) setLoggerConfig(loggerConfig);
    // optional info to work in test render
    logger?.info('Initial setup finished');
  }, [loggerConfig]);
  useTheme({
    cssHref: process.env.USE_THEME_URL || appConfig?.theme?.fields.file.url,
    font: appConfig?.font,
  });

  React.useEffect(() => {
    if (lcid && nonce && payload) {
      sessionStorage.setItem('silentAuth', JSON.stringify({ lcid, nonce, payload }));
    }
  }, [nonce]);

  // Deep-linking reading path and storing in session
  React.useEffect(() => {
    if (queryParamDeepLink) {
      sessionStorage.setItem('link', queryParamDeepLink);
    }
    modeType && document.body.classList.add(modeType);
  }, [queryParamDeepLink, modeType]);

  React.useEffect(() => {
    app.registerAction('languageChange', (lng: string) =>
      handleLocalization(Lang.change, lng, config, setIsLocalized),
    );
    if (smartRedirect) {
      sessionStorage.setItem('smartRedirect', smartRedirect);
    }
    window['version'] = process.env.VERSION;
  });

  React.useEffect(() => {
    if (!appConfig?.config) {
      return;
    }
    //set app hydration
    AppHydration.setHydration(appConfig?.config?.fields?.functionalConfig?.hydrate);
    const defaultLocale = getDefaultLocale();

    handleLocalization(Lang.init, defaultLocale || 'en-US', config, setIsLocalized);
  }, [appConfig]);

  React.useEffect(() => {
    if (typeof $sfr !== "undefined") {
      $sfr.istHeaderHome();
      $sfr.istFooter();
    }
  }, []);
  
  return (
    <>
      <Actions config={config} />
      {isLocalized && template === 'Simple' && <Simple config={config} />}
      {isLocalized && template === 'Standard' && <Standard config={config} />}
    </>
  );
}
